module.exports = __webpack_public_path__ + "static/img/1.54285dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/2/eng/1.png
// module id = UAVx
// module chunks = 0